<template>
  <product-section-card :title="$t('branch_detail.tab.purchase_guide')" class="product-section-need-to-know">
    <div class="relative">
      <div id="purchase-guide-preview-gallery" ref="previewRef" class="preview-content" :class="{ 'pb-5': !isOverflowing }">
        <content-data v-for="(node, idx) in purchaseNotice" :key="idx" :node="node" />
      </div>
      <div v-if="isOverflowing" class="preview-mask absolute bottom-0 left-0 right-0 h-[60px] pointer-events-none" />
    </div>

    <content-viewer
      v-if="isOverflowing"
      :title="$t('branch_detail.tab.purchase_guide')"
      :is-full-height="true"
      :is-footer-shown="false"
      :is-fallback-shown="true"
      main-content-class="pt-5 pb-10"
      viewer-class="lg:w-892px"
    >
      <template #trigger="{ open }">
        <product-view-all-button @view-all-click="open" />
      </template>
      <product-content-modal-body :nodes="purchaseNotice" gallery-id="purchase-guide-modal-gallery" />
    </content-viewer>
  </product-section-card>
</template>

<script lang="ts" setup>
import ContentData from '@/components/common/content-data.vue'
import ContentViewer from '@/components/common/content-viewer.vue'
import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'
import ProductContentModalBody from '@/components/product/product-detail/product-content-modal-body.vue'
import ProductSectionCard from '@/components/product/product-detail/product-section-card.vue'

import type { ProductContentData } from '@/types/product'

interface Props {
  /** 「購買須知」靜態內容的 tree node 陣列 */
  nodes: ProductContentData[]
}

const props = defineProps<Props>()

const purchaseNotice = computed(() => props.nodes ?? [])

const GALLERY_ID = 'purchase-guide-preview-gallery'

const isOverflowing = ref(false)
const previewRef = useTemplateRef<HTMLElement>('previewRef')

const { init: initPreviewLightbox } = useLightbox(GALLERY_ID)

useResizeObserver(previewRef, () => {
  if (previewRef.value) {
    isOverflowing.value = previewRef.value.scrollHeight > previewRef.value.clientHeight
  }
})

onMounted(() => {
  initPreviewLightbox()
})
</script>

<style lang="scss" scoped>
.preview-content {
  max-height: 400px;
  overflow: clip;
}

.preview-mask {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
}
</style>
